export function ensureTrailingSlash(url: string | null | undefined): string | null {
  if (url === null || url === undefined) {
    return null;
  }
  return url.endsWith('/') ? url : `${url}/`;
}
